import { RequestedListing } from "../../types";
import PromoterGroupClubRows from "./PromoterGroupClubRows";

interface PromoterRequestedClubsListProps {
  city: string;
  requestedListings: RequestedListing[];
}

const PromoterRequestedClubsList: React.FC<PromoterRequestedClubsListProps> = ({
  city,
  requestedListings,
}) => {
  const clubNames = requestedListings
    .map((listing) => listing.clubName || listing.title)
    .filter((clubName): clubName is string => Boolean(clubName));

  if (clubNames.length === 0) {
    return null;
  }

  return (
    <div className="promoter-group-detail__offers">
      <h3 className="promoter-group-detail__section-title">REQUESTED CLUBS</h3>
      <PromoterGroupClubRows
        city={city}
        clubs={clubNames.map((clubName) => ({ clubName }))}
      />
    </div>
  );
};

export default PromoterRequestedClubsList;
